import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53b96d5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { id: "printableGeneralJournal" }
const _hoisted_5 = { class: "m-2 mt-4 mb-4 p-text-center" }
const _hoisted_6 = { class: "p-mt-2" }
const _hoisted_7 = { class: "table table-bordered table-hover" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"#004C97","color":"#fff"} }, [
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "ACCOUNT TITLE AND EXPLANATION"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "DEBIT"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "CREDIT")
], -1))
const _hoisted_9 = { class: "p-p-1" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "p-p-1" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { style: {"background-color":"#eee"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "p-p-1" }, "TOTAL", -1))
const _hoisted_15 = { class: "p-p-1" }
const _hoisted_16 = { class: "p-p-1" }
const _hoisted_17 = { style: {"background-color":"#ccc"} }
const _hoisted_18 = {
  class: "p-p-1",
  colspan: "3"
}
const _hoisted_19 = { class: "p-mx-5" }
const _hoisted_20 = { class: "p-mx-5" }
const _hoisted_21 = { class: "p-mx-5" }
const _hoisted_22 = { class: "p-mx-5" }
const _hoisted_23 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search",
  style: {"font-size":"1.2rem"}
}, null, -1))
const _hoisted_25 = { class: "p-field" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Filter Date", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "OR", -1))
const _hoisted_28 = { class: "p-grid" }
const _hoisted_29 = { class: "p-col" }
const _hoisted_30 = { class: "p-field" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "from" }, "Date From", -1))
const _hoisted_32 = { class: "p-col" }
const _hoisted_33 = { class: "p-field" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "to" }, "Date To", -1))
const _hoisted_35 = { class: "p-grid pt-3" }
const _hoisted_36 = { class: "p-col" }
const _hoisted_37 = { class: "p-field" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Branch", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text p-p-1"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              icon: "pi pi-search",
              class: "p-button-success px-4",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              icon: "pi pi-print",
              class: "p-button-primary px-4",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printReceiptUtil('printableGeneralJournal', _ctx.storeName + ' General Journal')))
            })
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.storeName) + " Statement of General Journal", 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.resultTitle), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _hoisted_8,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lists, (l, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: l }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(l.transactionEntries, (sub) => {
                  return (_openBlock(), _createElementBlock("tr", { key: sub }, [
                    _createElementVNode("td", {
                      class: _normalizeClass(["p-p-1", {'padding-left': sub.type == 'Credit'}])
                    }, _toDisplayString(sub.accountName), 3),
                    _createElementVNode("td", _hoisted_9, [
                      (sub.type == 'Debit')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.formatAmount(sub.amount)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_11, [
                      (sub.type == 'Credit')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.formatAmount(sub.amount)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128)),
                _createElementVNode("tr", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.sumTotalAmount(l.transactionEntries,'Debit'))), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.sumTotalAmount(l.transactionEntries,'Credit'))), 1)
                ]),
                _createElementVNode("tr", _hoisted_17, [
                  _createElementVNode("td", _hoisted_18, [
                    _createTextVNode(" SNO : " + _toDisplayString(_ctx.totalRecords - (_ctx.currentPage - 1) * 20 - i) + " ", 1),
                    _createElementVNode("span", _hoisted_19, " Date : " + _toDisplayString(_ctx.moment(l.createdAt).format('DD-MM-YYYY')) + " / " + _toDisplayString(_ctx.moment(l.createdAt).format('hh:mm A')), 1),
                    _createElementVNode("span", _hoisted_20, " Source: " + _toDisplayString(l.generatedSource), 1),
                    _createElementVNode("span", _hoisted_21, " Narration: " + _toDisplayString(l.narration), 1),
                    _createElementVNode("b", _hoisted_22, "Store : " + _toDisplayString(l.branchName.name) + " (" + _toDisplayString(l.branchName.code) + ")", 1)
                  ])
                ])
              ], 64))
            }), 128))
          ]),
          (_ctx.totalRecords > 0)
            ? (_openBlock(), _createBlock(_component_Paginator, {
                key: 0,
                rows: 20,
                totalRecords: _ctx.totalRecords,
                first: (_ctx.currentPage - 1) * 20,
                onPage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPage($event))),
                template: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
              }, null, 8, ["totalRecords", "first"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_Dialog, {
        visible: _ctx.productDialog,
        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.productDialog) = $event)),
        style: { width: '50vw' },
        maximizable: true,
        position: "top",
        class: "p-fluid"
      }, {
        header: _withCtx(() => [
          _createElementVNode("h5", _hoisted_23, [
            _hoisted_24,
            _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "submit",
            label: "Search",
            icon: "pi pi-search",
            class: "p-button-primary",
            onClick: _ctx.searchAndLoad
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.searchFilters.filterType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchFilters.filterType) = $event)),
              options: _ctx.filterDates,
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearForFilters())),
              filter: true,
              optionLabel: "key",
              optionValue: "value"
            }, null, 8, ["modelValue", "options"])
          ]),
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "from",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchFilters.date1) = $event)),
                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args))),
                  class: "form-control",
                  min: "2026-08-07"
                }, null, 544), [
                  [_vModelText, _ctx.searchFilters.date1]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "to",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchFilters.date2) = $event)),
                  onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args))),
                  class: "form-control",
                  min: "2026-08-07"
                }, null, 544), [
                  [_vModelText, _ctx.searchFilters.date2]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.searchFilters.storeID,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchFilters.storeID) = $event)),
                  options: _ctx.filterBranch,
                  filter: true,
                  optionLabel: "name",
                  optionValue: "id"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}